// extracted by mini-css-extract-plugin
var _1 = "EmbedFooter-module__action--UJjbF";
var _2 = "EmbedFooter-module__animatedBackground--g0L4i";
var _3 = "EmbedFooter-module__container--GTskR";
var _4 = "EmbedFooter-module__hasNativeFooter--XSue4";
var _5 = "EmbedFooter-module__icon--tZIgq";
var _6 = "EmbedFooter-module__link--RknyI";
var _7 = "EmbedFooter-module__title--g9pSM";
export { _1 as "action", _2 as "animatedBackground", _3 as "container", _4 as "hasNativeFooter", _5 as "icon", _6 as "link", _7 as "title" }
